// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h5[data-v-ffa11e66]{font-style:normal;line-height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
